export default "__VITE_ASSET__BWOZzHWC__"